import type React from 'react';

import classes from './ToolDisplay.module.css';

export interface ToolContentProps {
  children: Exclude<React.ReactNode, boolean | null | undefined>[];
}

export function ToolContent({ children }: ToolContentProps) {
  if (!children?.length) {
    return null;
  }
  return <div className={classes.toolContent}>{children}</div>;
}
